import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { GetAllCrewFiltered_getAllCrewFiltered as Crew } from '../../../types/schemaTypes';
import { CustomButton } from '../../_common';
import SearchableDropdown from '../../_common/SearchableDropdown/SearchableDropdown';
import { Textfield } from '../../_common/Textfield/Textfield';
import { ModalForm } from '../interface';
import './AddEditCrewModal.scss';

interface Option {
    id: number | string;
    name: string | number;
}

interface AddEditCrewModalProps {
    modalForm: ModalForm;
    options: Option[];
    selectedCrew?: Crew;
    onClickHide: () => void;
    onClickSave: (id: number, crewNumber: string, customerId: number) => void;
    show: boolean;
    errorMessage?: string;
}

const AddEditCrewModal = ({
    show,
    options,
    onClickHide,
    onClickSave,
    modalForm,
    selectedCrew,
    errorMessage,
}: AddEditCrewModalProps): React.ReactElement => {
    const [selectedId, setSelectedId] = useState(0);
    const [selectedCrewNumber, setSelectedCrewNumber] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState(0);

    const isEditForm = modalForm === ModalForm.EDIT_CREW;

    useEffect(() => {
        if (selectedCrew) {
            setSelectedId(selectedCrew.id ? selectedCrew.id : 0);
            setSelectedCrewNumber(selectedCrew.crewNumber ? selectedCrew.crewNumber : ' ');
            setSelectedCustomer(selectedCrew.customerId ? selectedCrew.customerId : 0);
        }
    }, [selectedCrew]);

    const clearState = (): void => {
        setSelectedId(0);
        setSelectedCrewNumber('');
        setSelectedCustomer(0);
    };

    const onSave = (): void => {
        onClickSave(selectedId, selectedCrewNumber, selectedCustomer);
        clearState();
    };

    const onCancel = (): void => {
        clearState();
        onClickHide();
    };

    const setSaveButtonStatus = (): boolean => {
        const isNameValid = selectedCrewNumber.trim().length > 2 ? true : false;
        const isCustomerValid = selectedCustomer != 0 ? true : false;

        const isFormValid = isNameValid && isCustomerValid;

        return !isFormValid;
    };

    const changeName = (event: any): void => {
        setSelectedCrewNumber(event.target.value);
    };

    const getCustomerName = (): string | number | null => {
        const id = selectedCrew && selectedCrew.customerId ? selectedCrew.customerId.toString() : '';

        if (id == '') return null;

        const numId = parseInt(id);
        const filteredCustomer = options.filter((item: Option) => item.id === numId);

        
       
        const customer =  (filteredCustomer.length > 0) ? filteredCustomer[0].name: ''

        return customer;
    };

    const changeCustomer = (value: any): void => {
        const id = parseInt(value);
        setSelectedCustomer(id);
    };

    return (
        <Modal show={show} onHide={onClickHide} size="lg">
            <Modal.Header className="AddEditCrewModal-Header">
                <Modal.Title className="AddEditCrewModal-Header-Container">
                    <button className="material-icons AddEditCrewModal-X-Button" onClick={onClickHide}>
                        close
                    </button>
                    <div className="AddEditCrewModal-Title">{isEditForm ? 'Edit Crew' : 'Create New Crew'}</div>
                    <div className="AddEditCrewModal-ErrorMessage">{errorMessage}</div>
                </Modal.Title>
            </Modal.Header>
            <div className="AddEditCrewModal-Upper-TextField-Container">
                <div className="AddEditCrewModal-Textfield">
                    <Textfield
                        label="CrewName"
                        value={selectedCrew !== undefined ? selectedCrew.crewNumber : ''}
                        onChange={(event): void => changeName(event)}
                        onBlur={() => {}}
                    />
                </div>
            </div>
            <div className="AddEditCrewModal-Down-TextField-Container">
                <SearchableDropdown
                    dropdownOptions={options}
                    id="customer"
                    label="Customer"
                    onSelect={(eventKey: string | null) => {
                        changeCustomer(eventKey);
                    }}
                    value={getCustomerName()}
                />
            </div>
            <Modal.Footer className="AddEditCrewModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onCancel}></CustomButton>
                <CustomButton title="Save" isDisabled={setSaveButtonStatus()} onClick={onSave}></CustomButton>
            </Modal.Footer>
        </Modal>
    );
};

export default AddEditCrewModal;

